// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"98d5de55","488":"ce521843","732":"8209e6d6","977":"cdb37c01"}[chunkId] + ".chunk.js";
};